import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import withPrimeContext from "../withPrimeContext";
import WaitingPageLabelMeta from "~/components/engage/Waitings/WaitingPageLabelMeta/WaitingPageLabelMeta";

export default withPrimeContext(
  withErrorBoundary(WaitingPageLabelMeta, {
    name: "WaitingPageLabelMetaComponent",
  }),
);
